import React from "react";
import { useRouter } from "next/router";
import Layout from "components/Layout";
import { BackHeader } from "@xt/Nav";
import { Hooks, Platform } from "@xt/xtbase";
import RewardHubContent from "@/components/Pages/Activity/RewardHub";

const { useTranslation } = Hooks;

export default function RewardHubPage() {
  const router = useRouter();
  const t = useTranslation();

  const handleBack = () => {
    router.back();
  };

  return (
    <Layout isShowNav={false} isShowFoot={false} useBottomBar={false}>
      <BackHeader title={t("activity.rewardHub") || "Reward Hub"} onBack={handleBack} />
      <div
        style={{
          paddingTop: Platform.isInApp() ? "env(safe-area-inset-top, 0px)" : "calc(44px + env(safe-area-inset-top, 0px))",
        }}
      >
        <RewardHubContent />
      </div>
    </Layout>
  );
}
